/*eslint camelcase: ["error", {properties: "never"}]*/
const basketApi = require('services/api/basket');
const addBiRewardsToCart = require('services/api/beautyInsider/addBiRewardsToCart');
const removeBiRewardFromBasket = require('services/api/beautyInsider/removeBiRewardFromBasket');
const brazeUtils = require('analytics/utils/braze');
const basketUtils = require('utils/Basket');
const promoUtils = require('utils/Promos');
const skuUtils = require('utils/Sku');
const anaUtils = require('analytics/utils');
const urlUtils = require('utils/Url');
const profileApi = require('services/api/profile');
const { getProp } = require('utils/Helpers');
const Actions = require('Actions');
const processEvent = require('analytics/processEvent');
const analyticsConsts = require('analytics/constants');
const inlineBasketActions = require('./InlineBasketActions');
const UtilActions = require('utils/redux/Actions');
const rewardActions = require('./RewardActions');
const updateCurrentUserSpecificProduct = require('actions/ProductActions').
    updateCurrentUserSpecificProduct;
const birbActions = require('./BIRBActions');
const beautyInsiderActions = require('./BeautyInsiderActions');
const Location = require('utils/Location');
const localeUtils = require('utils/LanguageLocale');
const getText = localeUtils.getLocaleResourceFile('actions/locales', 'BasketActions');
const Storage = require('utils/localStorage/Storage');
const LOCAL_STORAGE = require('utils/localStorage/Constants');
const basketConstants = require('constants/Basket');
const BASKET_EXPIRY = Storage.MINUTES * 15;
const TYPES = require('reducers/basket').ACTION_TYPES;
const BASKET_TYPES = {
    PREBASKET: 'prebasket',
    DC_BASKET: 'distribution center basket',
    ROPIS_BASKET: 'reserve and pick up basket',
    BOPIS_BASKET: 'buy online and pick up basket'
};
const HTTP_STATUS_ACCEPTED = 202;
const OPERATION = {
    ADDED_PRODUCT: 'ADDED_PRODUCT',
    ADDED_PRODUCT_BASKET_UPDATE: 'ADDED_PRODUCT_BASKET_UPDATE',
    UPDATED_PRODUCT: 'UPDATED_PRODUCT',
    ADDED_REWARD: 'ADDED_REWARD',
    ADDED_SAMPLE: 'ADDED_SAMPLE'
};
const PROMO_TO_BE_REMOVED = -10102;

function sendBrazeBasketValueEvent(subtotal) {
    global.appboy && appboy.logCustomEvent(
        'basketValue',
        { 'subtotal': subtotal }
    );
}
const TestTargetActions = require('actions/TestTargetActions');

const WARNING = 'warning';
const ERROR = 'error';
const PROMO_WARNING = 'basket.promoWarning';
const PROMO_INVALID = 'basketLevelMsg';

function updateBasket(basket) {
    /* We cache basket data each time the basket is updated with fresh API data so we do not have
     to call the user/full API on each page load. However, we set an expire time of 15 minutes. */
    Storage.local.setItem(LOCAL_STORAGE.BASKET, basket, BASKET_EXPIRY);

    basket.isInitialized = true;
    if (basket.pickupBasket) {
        basket.pickupBasket.isInitialized = true;
    }

    const { brazeIsReady } = Sephora.analytics.promises;
    brazeIsReady && brazeIsReady.then(() => {
        if (brazeUtils.setNewData('itemsInBasket', basket.itemCount)) {
            global.appboy && appboy.getUser().setCustomUserAttribute(
                'itemsInBasket', basket.itemCount
            );
        }
    });

    sendBrazeBasketValueEvent(basket.subtotal);

    return {
        type: TYPES.UPDATE_BASKET,
        basket: basketUtils.separateItems(basket)
    };
}

function updatePickupStoreDetails(storeDetails) {
    return {
        type: TYPES.UPDATE_PICKUP_STORE_DETAILS,
        storeDetails: storeDetails
    };
}

function showError(error, items, errorMessages) {
    // errors array is empty for next case (that's why we use errorMessages):
    // errorCode: -1081
    // 'There is a limit of 10 per person for this item. We have added 0 item(s) to your basket.'
    let basketError = Object.assign({}, error);
    if (error) {
        if (error.errors && !Object.keys(error.errors).length) { // sometimes it is empty
            basketError.errorMessages = error.errorMessages;
        } else if (!Object.keys(error).length && errorMessages) {
            basketError.errorMessages = errorMessages;
        }
    }
    if (error && !basketError.errorMessages && (typeof error === 'object')) {
        basketError.errorMessages = Object.keys(error).map(errorKey => {
            if (error[errorKey] instanceof Array) {
                return error[errorKey].join(',');
            } else {
                return error[errorKey];
            }
        });
    }
    return {
        type: TYPES.SHOW_BASKET_ERROR,
        error: basketError,
        itemsAndErrors: items || null
    };
}

function addPendingProduct(skus) {
    let store = require('Store');

    if (!Array.isArray(skus)) {
        skus = [skus];
    }

    let pendingBasketSkus = store.getState().basket.pendingBasketSkus.concat(skus);
    return {
        type: TYPES.ADD_PENDING_SKU,
        pendingBasketSkus: pendingBasketSkus
    };
}

function removePendingProduct(sku) {
    let store = require('Store');
    let pendingBasketSkus = store.getState()
        .basket
        .pendingBasketSkus
        .filter(item => item.skuId !== sku.skuId || item.methodId !== sku.methodId);
    return {
        type: TYPES.REMOVE_PENDING_SKU,
        pendingBasketSkus: pendingBasketSkus
    };
}

function clearPendingProductList() {

    return {
        type: TYPES.CLEAR_PENDING_SKU,
        pendingBasketSkus: []
    };
}

function showWarning(basketItemWarnings) {
    return {
        type: TYPES.SHOW_BASKET_WARNING,
        basketItemWarnings: basketItemWarnings
    };
}

function refreshBasket(keepItemLevelErrors) {
    return (dispatch) => {
        return basketApi.getBasketDetails().
            then(data => {
                if (keepItemLevelErrors && data.items) {
                    let itemsAndErrs = basketUtils.catchItemLevelErrors(
                        keepItemLevelErrors, data);
                    if (itemsAndErrs) {
                        data.items.forEach(item => {
                            let itemErr =
                                itemsAndErrs.filter(err => err.sku.skuId === item.sku.skuId);
                            if (itemErr.length) {
                                item = Object.assign(item, itemErr[0]);
                            }
                        });
                    }
                }
                return dispatch(updateBasket(data));

            }).catch(reason => {
                return dispatch(showError(reason));
            });
    };
}

function confirmBasketUpdateModal(dispatch, message, callback, cancelCallback) {
    dispatch(
        Actions.showInfoModal({
            isOpen: true,
            title: getText('confirmBasketUpdateModalTitle'),
            message: message,
            buttonText: getText('confirmBasketUpdateModalButtonText'),
            callback: callback,
            showCancelButton: true,
            cancelCallback: cancelCallback,
            showCloseButton: true
        })
    );
}

function showPaypalRestrictedMessage() {
    return {
        type: TYPES.SHOW_PAYPAL_RESTRICTED_MESSAGE,
        showPaypalRestrictedMessage: true,
        isPickup: basketUtils.isPickup()
    };
}

function showStickyApplePayBtn(isSticky) {
    return {
        type: TYPES.SHOW_STICKY_APPLE_PAY_BTN,
        showStickyApplePayBtn: isSticky
    };
}

// Fetch rewards only for basket, BI, and BIRB pages if there is a change in the basket.
// Related to ILLUPH-124729, ILLUPH-125321 and ILLUPH-126428
// Rewards must be fetched/updated after add product in basket page
function fetchRewardsAfterBasketUpdate(dispatch, sku = null) {
    if (Location.isBasketPage()) {
        dispatch(rewardActions.fetchProfileRewards());
    }

    if (Location.isBIRBPage()) {
        dispatch(birbActions.fetchBiRewards());
    }

    if (Location.isBIPage()) {
        dispatch(beautyInsiderActions.fetchBiRewards());
    }

    if (Location.isProductPage() && sku
        && sku.rewardSubType === skuUtils.skuTypes.ROUGE_REWARD_CARD) {
        let productName = urlUtils.getUrlLastFragment().toLowerCase();
        let productId = productName.split('-').pop().toUpperCase();
        dispatch(birbActions.fetchBiRewards());
        profileApi.getUserSpecificProductDetails(productId).then((response) => {
            dispatch(updateCurrentUserSpecificProduct(response));
        });
    }
}

function filterBasketWarningErrorMessages({ basketLevelMessages }) {
    let store = require('Store');

    const warningErrorMessages = basketLevelMessages&&basketLevelMessages.filter((msg)=>{
        return (
            (msg.type === WARNING || msg.type === ERROR)
            &&
            (msg.messageContext === PROMO_WARNING || msg.messageContext === PROMO_INVALID)
        );
    })||[];

    if ( warningErrorMessages.length ){
        const message = warningErrorMessages[0].messages[0];

        if (Location.isProductPage()) {
            store.dispatch(UtilActions.merge('inlineBasket', 'isOpen', true));
            store.dispatch(showError({ internalError: message }));
        } else {
            promoUtils.showWarningMessage(message);
        }
    }
}


/**
 * Since the current API response sometimes retrieves errors inside the
 * basket and sometimes within a totally different format,
 * this method will check always for errors.lso this it will dispatch
 * different actions relevant to the operation that called this function.
 *
 * OPERATION.UPDATED_PRODUCT: dispatch updateBasket with the straight basket response.
 * OPERATION.ADDED_PRODUCT: calculate new basket object using the basket response.
 * ADDED_PRODUCT_BASKET_UPDATE: dispatch updateBasket with the straight basket response.
 * Else for ADDED_REWARD: dispatch updateBasket with straight basket response.
 * NOTE:For the last 2 cases, if it comes the quantity param it dispatches addedProductsNotification
 */
function makeGenericAddUpdateProductToBasketSuccessHandler(
    dispatch, isRopisSku, quantity, performedAction, successCallback) {
    return (data) => {
        if (typeof successCallback === 'function') {
            successCallback(data);
        }

        // operation-specifyc logic
        let updatedBasket = null;

        switch (performedAction) {
            case OPERATION.UPDATED_PRODUCT:
            case OPERATION.ADDED_PRODUCT_BASKET_UPDATE:
            case OPERATION.ADDED_SAMPLE:
                updatedBasket = updateBasket(data);
                break;
            case OPERATION.ADDED_PRODUCT:

                //When adding a product to basket,
                // the api response does not contain the full basket
                updatedBasket = updateBasket(basketUtils.calculateUpdatedBasket(data));
                break;
            case OPERATION.ADDED_REWARD:
                updatedBasket = updateBasket(data.basket);
                break;
            default:
                updatedBasket = updateBasket(data.basket);
                break;
        }

        dispatch(updatedBasket);

        fetchRewardsAfterBasketUpdate(dispatch);

        if (isRopisSku) {
            dispatch(inlineBasketActions.ReserveOnlinePickUpInStoreProductAdded(true));
        } else {
            dispatch(inlineBasketActions.ReserveOnlinePickUpInStoreProductAdded(false));
        }

        if (quantity) {
            dispatch(inlineBasketActions.addedProductsNotification(quantity));
        }

        if (!Location.isBasketPage() && Sephora.isMobile()) {
            dispatch(UtilActions.merge('inlineBasket', 'isOpen', true));
        }

        dispatch(showWarning(basketUtils.catchItemLevelMessages(data)));
        return updatedBasket;
    };
}

function makeGenericBasketOperationFailureHandler(dispatch) {
    return reason => {
        if (!Location.isBasketPage()) {
            dispatch(UtilActions.merge('inlineBasket', 'isOpen', true));
        }

        let itemsAndErrors = basketUtils.catchItemLevelErrors(reason);
        dispatch(showError(reason.errors, itemsAndErrors, reason.errorMessages));
        dispatch(refreshBasket(itemsAndErrors ? reason : null));
        return Promise.reject(reason);
    };
}

function updateQuantities(skuList, successCallback, modifyConfirmed, isRopisSku) {
    let orderId = basketUtils.getOrderId();

    return dispatch => {
        return basketApi.updateBasket({
            orderId,
            skuList,
            modifyConfirmed,
            isRopis: isRopisSku
        }).
            then(data => {
                let promise;

                if (data.responseStatus === HTTP_STATUS_ACCEPTED) {
                    confirmBasketUpdateModal(dispatch, data.errorMessages.join('. '), () => {
                        dispatch(updateQuantities(skuList, () => {
                            if (data.errorCode === PROMO_TO_BE_REMOVED) {
                                promoUtils.removePromo();
                            }
                            successCallback.apply(null, arguments);
                        }, true));

                        dispatch(Actions.showInfoModal({ isOpen: false }));
                    }, () => {
                        dispatch(refreshBasket());
                    });

                    promise = Promise.resolve(null);
                } else {
                    promise = Promise.resolve(data);
                }

                return promise;
            }).
            then(data => {
                // data can be null here because of 202 responseStatus in the above clause.
                let handler = data && makeGenericAddUpdateProductToBasketSuccessHandler(
                    dispatch, null, null, OPERATION.UPDATED_PRODUCT, successCallback);
                handler && handler(data);
            }).
            catch(makeGenericBasketOperationFailureHandler(dispatch));
    };
}

function addProductToBasket(sku, isRopisSku, quantity, includeAllBasketItems, successCallback) {
    quantity = quantity || 1;

    return dispatch => {
        return basketApi.addToCart({
            orderId: basketUtils.getOrderId(),
            skuList: [{
                isAcceptTerms: skuUtils.isFlash(sku),
                qty: quantity,
                skuId: sku.skuId
            }],
            fulfillmentType: isRopisSku ? 'ROPIS' : null
        }, (isRopisSku || includeAllBasketItems)).then(
            makeGenericAddUpdateProductToBasketSuccessHandler(
                dispatch,
                isRopisSku,
                quantity,
                includeAllBasketItems ? OPERATION.ADDED_PRODUCT_BASKET_UPDATE : OPERATION.ADDED_PRODUCT,
                successCallback
            )
        ).then(
            ( data )=>{
                filterBasketWarningErrorMessages(data.basket);
                return data;
            })
            .catch(makeGenericBasketOperationFailureHandler(dispatch));
    };
}

function addRewardToBasket(skuId, quantity, successCallback) {
    return dispatch => {
        return addBiRewardsToCart(skuId).
            then(makeGenericAddUpdateProductToBasketSuccessHandler(
                dispatch, null, quantity, OPERATION.ADDED_REWARD, successCallback)).
            catch(makeGenericBasketOperationFailureHandler(dispatch));
    };
}

// Prepare data for Google Analytics begin_checkout event (Add To Cart & Remove from Cart)
function getCurrentBasketItemsForGoogleAnalytics () {
    let store = require('Store');
    let currentBasketItems = store.getState().basket.items;
    let analyticsBasketItems = [];
    currentBasketItems.forEach((basketItem) => {
        let currentSku = basketItem.sku;
        let skuPrice = anaUtils.removeCurrencySymbol(currentSku.salePrice || currentSku.listPrice);
        let brand = currentSku.brandName ? currentSku.brandName : basketItem.manufacturer;
        let itemToAdd = {
            id: currentSku.skuId,
            name: currentSku.productName,
            brand: brand,
            category: currentSku.parentCategory && currentSku.parentCategory.displayName,
            variant: currentSku.variationValue || '',
            skuType: currentSku.type,
            quantity: basketItem.qty || 1,
            price: isNaN(skuPrice) ? '0.00' : skuPrice
        };
        analyticsBasketItems.push(itemToAdd);
    });
    return analyticsBasketItems;
}

/*
 * Call Custom Event to fire Google Analytics begin_checkout event for following events:
 * 1. Add To Cart
 * 2. Remove from Basket
 * 3. Change in Quantity
 * 4. Move to Loves
 * @params  item    sku to be added to or removed from current basket
 * @params  action  addItem or removeItem
 */
function fireGABeginCheckout (item, action) {
    let currentItems = getCurrentBasketItemsForGoogleAnalytics();
    let itemList = [];
    let isItemAlreadyInList = currentItems.filter(product => product.id === item.id);
    switch (action) {
        case 'addItem':
            itemList = [...currentItems];
            break;
        case 'removeItem':
            itemList = currentItems.filter(product => product.id !== item.id);
            break;
        case 'editQuantity':
            currentItems.forEach(product => {
                if (product.id === item.id) {
                    product.quantity = item.quantity;
                    itemList.push(product);
                } else {
                    itemList.push(product);
                }
            });
            break;
        default:
            itemList = [];
    }

    if (digitalData.page.attributes.tempProps) {
        digitalData.page.attributes.tempProps.cartItems = itemList;
    } else {
        digitalData.page.attributes.tempProps= {};
        digitalData.page.attributes.tempProps.cartItems = itemList;
    }

    Sephora.analytics.promises.tagManagementSystemReady.then(() => {
        let addToCartPixels = require('analytics/addToCartPixels');
        addToCartPixels.googleAnalyticsBeginCheckout();
    });
}

function handleAddToBasketAnalytics(data) {
    let promises = Sephora.analytics.promises;
    let { analyticsContext } = data;
    const { sku, skuList, analyticsData, quantity } = data;
    const originalContext = (analyticsData && analyticsData.originalContext) || undefined;
    if (digitalData.page.attributes.tempProps.isEnrollToFlash) {
        analyticsContext = analyticsConsts.CONTEXT.ROUGE_ENROLL_FLASH;
    }
    const addToBasketEvent = require('analytics/bindings/pages/all/addToBasketEvent');
    let anaData = {
        bindingMethods: [addToBasketEvent],
        context: analyticsContext,
        originalContext,
        sku: sku,
        skuList,
        analyticsData: analyticsData,
        eventName: analyticsConsts.EVENT_NAMES.ADD_TO_BASKET
    };
    if (analyticsContext === analyticsConsts.CONTEXT.QUICK_LOOK && analyticsData.isCertonaProduct) {
        anaData.internalCampaign = `${analyticsData.rootContainerName}:${analyticsData.productId}:add-to-basket`.toLowerCase();
    }
    processEvent.preprocess.commonInteractions(anaData);

    // require.ensure is used to package nested requires in components.chunk.js
    // rather than priority.bundle.js in order to keep priority.bundle.js lean
    require.ensure([], function (require) {

        let isFlashSku = skuUtils.isFlash(sku);
        let isRestrictedForPixel = isFlashSku || skuUtils.isGiftCard(sku) || skuUtils.isBiRewardGwpSample(sku);
        let totalAmount = anaUtils.removeCurrencySymbol(sku.salePrice || sku.listPrice);
        let skuPriceForLocale = totalAmount;
        totalAmount = anaUtils.convertToUSD(totalAmount);
        let manufacturer = digitalData?.product[0] ? digitalData.product[0].productInfo.manufacturer : '';
        let brand = sku.brandName || manufacturer;
        let googleAnalyticsAddToBasketData = {
            id: sku.skuId,
            name: analyticsData.productName,
            brand,
            category: analyticsData.category || '',
            variant: sku.variationValue || '',
            skuType: sku.type,
            quantity: quantity || 1,
            price: skuPriceForLocale,
            currency: localeUtils.isCanada() ? localeUtils.ISO_CURRENCY.CA : localeUtils.ISO_CURRENCY.US
        };
        let addToCartPixels = require('analytics/addToCartPixels');

        // AddToCart PIXELS should not fire for Flash, Gift Card, Samples, GWP & Rewards
        if (!isRestrictedForPixel) {
            Sephora.analytics.promises.tagManagementSystemReady.then(() => {
                let lineItems = [];
                lineItems.push({
                    product_name: analyticsData.productName,
                    product_id: sku.skuId,
                    product_price: totalAmount,
                    product_quantity: quantity
                });
                let eventData = {
                    totalAmount: totalAmount,
                    quantity: quantity,
                    currency: 'USD',
                    lineItems: lineItems
                };
                addToCartPixels.pinterestAddToCartEvent(eventData);
                addToCartPixels.snapChatAddToCartEvent(totalAmount, quantity, 'USD', [sku.skuId]);
            });
        }

        if (!isFlashSku) {
            addToCartPixels.googleAnalyticsAddToBasketEvent(googleAnalyticsAddToBasketData);
            fireGABeginCheckout(googleAnalyticsAddToBasketData, 'addItem');
        }

        // UTS-684 Facebook pixel needs to fire for flash too
        let facebookAddToBasketData = {
            id: sku.skuId,
            quantity: quantity || 1,
            price: skuPriceForLocale,
            currency: localeUtils.isCanada() ? localeUtils.ISO_CURRENCY.CA : localeUtils.ISO_CURRENCY.US
        };
        addToCartPixels.facebookAddToBasketEvent(facebookAddToBasketData);

        promises.brazeIsReady.then(() => {
            global.appboy && appboy.logCustomEvent('addToBasket');
        });
    }, 'components');
}

function dispatchRemoveFromBasket(windowObj, itemData = {}) {
    let {
        productId, productName, brandName, variationValue, listPrice, salePrice, quantity
    } = itemData.sku;
    let removedFromBasketData = {
        id: itemData.sku?.skuId || itemData.sku?.primaryProduct?.productId,
        name: productName || variationValue,
        brand: brandName || '',
        variant: variationValue || '',
        quantity: quantity || 1,
        price: salePrice || listPrice
    };
    windowObj.dispatchEvent(new CustomEvent('RemoveFromBasket', { detail: removedFromBasketData }));
}

function trackItemRemoval(data) {
    dispatchRemoveFromBasket(window, data);
    const {
        sku, analyticsData = {}, analyticsContext
    } = data;
    const skuWithRemovalProperty = {
        ...sku, isRemoval: true
    };
    const isSample = skuUtils.isSample(sku);
    let {
        containerTitle = '', isBIRBPageRewardModal
    } = analyticsData;
    let removeText = 'remove from basket';
    let isBopisBasket = Storage.local.getItem(LOCAL_STORAGE.BASKET_TYPE) === BASKET_TYPES.BOPIS_BASKET;
    let intCampRemoveText = (analyticsContext === analyticsConsts.CONTEXT.BI_REWARDS_CAROUSEL) ?
        'remove-from-basket' : removeText;
    const actionInfo = containerTitle &&
        analyticsContext !== analyticsConsts.CONTEXT.CONTENT_STORE ?
        `${containerTitle}:${removeText}` : isBopisBasket ? 'basket:delete' :`${removeText}` ;
    const internalCampaign = containerTitle ?
        `${containerTitle}:${sku.productId}:${intCampRemoveText}` : !Location.isBasketPage() && intCampRemoveText;
    let recentEvent = anaUtils.getLastAsyncPageLoadData({ pageType: analyticsContext });

    processEvent.process(analyticsConsts.LINK_TRACKING_EVENT, {
        data: {
            bindingMethods: [require('analytics/bindings/pages/all/removeFromBasketEvent')],
            eventStrings: [analyticsConsts.Event.EVENT_71, analyticsConsts.Event.SC_REMOVE],
            linkName: isSample ?
                'Remove samples from Basket' : isBopisBasket ? 'basket:delete' : 'Remove From Basket',
            sku: skuWithRemovalProperty,
            actionInfo,
            internalCampaign,
            isBIRBPageRewardModal,
            ...recentEvent
        }
    });
}

/**
 * Add analytics to the originally passed in success callback
 * @param  {obj} data - All the data we need
 * @return {function} - A new function that will be used as the success callback
 */
function createDecoratedSuccessCallback(data) {
    return function () {
        const {
            successCallback: originalCallback = () => { },
            isInBasket = false, isBiReward
        } = data;
        isInBasket && isBiReward ? trackItemRemoval(data) : handleAddToBasketAnalytics(data);
        originalCallback.apply(null, arguments);
    };
}

function addMultipleSkusToBasket(
    skus, skusQuantity, successCallback, analyticsContext, analyticsData = {}, mainSku = {}) {
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    let mainSkuQty = 1;
    const skuQuantities = skus.map(sku => {
        if (mainSku.skuId === sku.skuId) {
            mainSkuQty = sku.qty;
        }
        return sku.qty;
    });
    let totalSkusQuantity = skuQuantities.reduce(reducer);

    return dispatch => {
        return basketApi.addToCart({
            orderId: basketUtils.getOrderId(),
            skuList: skus.map(sku => {
                return {
                    qty: sku.qty,
                    skuId: sku.skuId,
                    isAcceptTerms: sku.isAcceptTerms
                };
            })
        }).
            then(makeGenericAddUpdateProductToBasketSuccessHandler(
                dispatch, null, totalSkusQuantity, OPERATION.ADDED_PRODUCT, successCallback)).
            then(createDecoratedSuccessCallback({
                sku: mainSku,
                analyticsContext,
                analyticsData,
                skuList: skus,
                quantity: mainSkuQty
            })
            ).catch(makeGenericBasketOperationFailureHandler(dispatch));
    };
}

/**
 * Function to add a new sample to the basket
 * The 'Add Samples to Basket API' receives an array of samples sku.
 * If only one sku is added it will replace the list of samples added
 * previously
 * @param sku
 * @param quantity
 * @param successCallback
 */
function addSampleToBasket(sku, quantity, successCallback) {
    return (dispatch) => {
        // basket.samples contains an array of Sample objects,
        // we only need an array of Sample skuId
        let store = require('Store');
        const sampleSkuIdList = store.getState().basket.samples.map(item => item.sku.skuId);
        sampleSkuIdList.push(sku.skuId);

        return basketApi.addSamplesToBasket(sampleSkuIdList).
            then(makeGenericAddUpdateProductToBasketSuccessHandler(
                dispatch, null, quantity, OPERATION.ADDED_SAMPLE, successCallback)).
            catch(makeGenericBasketOperationFailureHandler(dispatch));
    };
}

/**
 * Removes an Sku from the Basket
 * @param  {Object} sku - The sku to be removed
 * @param  {Boolean} samplePanel - Whether or not the item removed is in the sample panel (optional)
 * @param  {Boolean} trackAna - Whether or not to track the removal (optional)
 * @param  {Boolean} modifyConfirmed - Appends modifyConfirmed=true to the url.  This is used when
 * calling a second time following a 202 response from the server (see API docs for details)
 * @returns {Function} Action to be performed
 */
function removeProductFromBasket({
    sku,
    samplePanel = false,
    trackAna = true,
    modifyConfirmed = false,
    isMergedBasket = false,
    isRopisSku = false
}) {
    return (dispatch) => {
        return basketApi.removeSkuFromBasket(
            basketUtils.getOrderId(), sku.skuId, modifyConfirmed, isRopisSku).
            then(data => {
                //if user adds flash to basket then signs in with a user
                //that is already flash, don't clear merged basket error msg
                //when we automatically remove flash from basket

                // require.ensure is used to package nested requires in components.chunk.js
                // rather than priority.bundle.js in order to keep priority.bundle.js lean
                require.ensure([], function (require) {
                    const certonaUtils = require('utils/certona');
                    const certonaConstants = require('utils/certonaConstants');

                    certonaUtils.sendCertona(
                        certonaConstants.CERTONA_EVENTS.REMOVE_FROM_BASKET,
                        { itemId: sku.skuId }
                    );
                }, 'components');

                filterBasketWarningErrorMessages(data);

                if (!(skuUtils.isFlash(sku) && isMergedBasket)) {
                    dispatch(showError());
                }

                // Extract promo warning from a basket level messages and set it as an error
                if (data.basketLevelMessages && data.basketLevelMessages.length) {
                    const errorMessages = data.basketLevelMessages.reduce((acc, msg) => {
                        if (msg.messageContext === basketConstants.PROMO_WARNING) {
                            acc.push(msg.messages[0]);
                        }
                        return acc;
                    }, []);

                    if (errorMessages.length) {
                        dispatch(showError(errorMessages));
                    }
                }

                trackAna && trackItemRemoval({
                    sku, samplePanel
                });
                dispatch(updateBasket(data));
                fetchRewardsAfterBasketUpdate(dispatch);
            }).
            catch(reason => {
                if (reason.responseStatus === HTTP_STATUS_ACCEPTED) {
                    let messages = reason.errorMessages;
                    // Append a period and a line break to the last product
                    if (Array.isArray(messages) && messages.length > 0) {
                        let lastProductName = messages[messages.length - 1];
                        lastProductName += '.';
                        messages[messages.length - 1] = lastProductName;
                        messages.push('');
                    }
                    messages.push(getText('sureToContinueMessage'));
                    confirmBasketUpdateModal(dispatch, messages.join(''), () => {
                        dispatch(removeProductFromBasket({
                            sku,
                            samplePanel,
                            trackAna,
                            modifyConfirmed: true,
                            isRopisSku
                        }));
                        dispatch(Actions.showInfoModal({ isOpen: false }));
                    });
                } else {

                    dispatch(showError(reason));
                }
            });
    };
}

function removeRewardFromBasket(sku, successCallback) {
    return (dispatch) => {
        return removeBiRewardFromBasket(
            basketUtils.getOrderId(), sku.skuId).
            then(data => {
                if (typeof successCallback === 'function') {
                    successCallback(data);
                }

                dispatch(updateBasket(data.basket));
                fetchRewardsAfterBasketUpdate(dispatch, sku);
                dispatch(showError());
            }).
            catch(reason => {
                let itemsAndErrors = basketUtils.catchItemLevelErrors(reason);
                dispatch(showError(reason.errors, itemsAndErrors, reason.errorMessages));
                return Promise.reject(reason);
            });
    };
}

/**
 * Determines the type of item to be removed and calls the corresponding action
 * @param  {Object} item - The item to be removed
 * @param  {Boolean} trackAna - Whether or not to track the removal (optional)
 * @param  {Boolean} isMergedBasket = Whether or not we are auto removing item from a merged basket
 * @returns {Function} Action to be performed
 */
function removeItemFromBasket(item, trackAna, isMergedBasket, isRopisSku = false) {
    return (dispatch) => {
        fireGABeginCheckout({ id: item.sku.skuId }, 'removeItem');
        item.sku.quantity = item.qty ? item.qty : 1;
        let isReward = skuUtils.isBiReward(item);
        if (isReward) {
            return dispatch(removeRewardFromBasket(item.sku));
        } else if (skuUtils.isGwp(item.sku)) {
            return promoUtils.removePromo();
        } else {
            return dispatch(
                removeProductFromBasket({
                    sku: item.sku,
                    samplePanel: false,
                    trackAna,
                    modifyConfirmed: false,
                    isMergedBasket,
                    isRopisSku
                }));
        }
    };
}

function addToBasket(
    sku, isRopisSku, qty, successCallback, analyticsContext, samplePanel = false, analyticsData = {}) {

    const isInBasket = skuUtils.isInBasket(sku.skuId);
    const isBiReward = skuUtils.isBiReward(sku);
    const isGiftCard = skuUtils.isGiftCard(sku);
    const quantity = parseInt(qty);
    const decoratedSuccessCallback =
        createDecoratedSuccessCallback({
            sku,
            successCallback,
            analyticsContext,
            analyticsData,
            isInBasket,
            samplePanel,
            isBiReward,
            quantity
        });

    let result;

    let googleAnalyticsChangedBasketData = {
        id: sku.skuId,
        name: analyticsData.productName,
        brand: analyticsData.brandName || '',
        variant: sku.variationValue || '',
        quantity: quantity || 1,
        price: '0.00'
    };

    if (isBiReward) {
        if (isInBasket) {
            result = removeRewardFromBasket(sku, decoratedSuccessCallback);
            fireGABeginCheckout(googleAnalyticsChangedBasketData, 'removeItem');
        } else {
            result = addRewardToBasket(sku.skuId, quantity, decoratedSuccessCallback);
        }
    } else if (skuUtils.isSample(sku)) {
        if (isInBasket) {
            result = removeProductFromBasket({
                sku, samplePanel
            });
            fireGABeginCheckout(googleAnalyticsChangedBasketData, 'removeItem');
        } else {
            result = addSampleToBasket(sku, quantity, decoratedSuccessCallback);
        }
    } else {
        result = addProductToBasket(
            sku,
            isRopisSku,
            quantity,
            !!Location.isBasketPage(),
            decoratedSuccessCallback
        );
    }

    return result;
}

function setBasketType(currentBasketType) {
    const sendBasketType = (Location.isBasketPage() || Location.isCheckout())
        && currentBasketType !== BASKET_TYPES.PREBASKET;

    Storage.local.setItem(LOCAL_STORAGE.BASKET_TYPE, currentBasketType, BASKET_EXPIRY);

    if (sendBasketType) {
        const TestTargetService = require('services/TestTarget');
        const store = require('Store');
        const doNotResetTestAndTarget = store.getState()?.testTarget?.readyState === TestTargetActions.OFFERS_READY_STATES.ADOBE_TESTS_RECEIVED;
        TestTargetService({ doNotResetTestAndTarget });
    }

    return {
        type: TYPES.SET_BASKET_TYPE,
        currentBasketType: currentBasketType
    };
}

module.exports = {
    TYPES,
    BASKET_TYPES,
    // skuType-independent add sku to basket.
    addToBasket,
    // Fully update basket in store with the new data.
    updateBasket,
    updatePickupStoreDetails,
    // Fetch basket from server and put it into store. No parameters needed.
    refreshBasket,
    removePendingProduct,
    addPendingProduct,
    clearPendingProductList,
    updateQuantities,
    removeItemFromBasket,
    removeProductFromBasket,
    showError,
    showWarning,
    addMultipleSkusToBasket,
    trackItemRemoval,
    showPaypalRestrictedMessage,
    showStickyApplePayBtn,
    dispatchRemoveFromBasket,
    handleAddToBasketAnalytics,
    fetchRewardsAfterBasketUpdate,
    fireGABeginCheckout,
    setBasketType
};
